import textFunction from "./textFunction";

const changeFunction = (data) => {
  // console.log(data)
    let excelDB = data

    for (let i = 0; i < excelDB.length; i++) {
        if (!excelDB[i].sentence_text) continue;
        const text = excelDB[i].sentence_text;
        const morphemeInfomation = {
          sentence_subject: excelDB[i].sentence_subject
            ? String(excelDB[i].sentence_subject).split(",").map((el) => {
                return Number(el);
              })
            : [],
          sentence_verb: excelDB[i].sentence_verb
            ? String(excelDB[i].sentence_verb).split(",").map((el) => {
                return Number(el);
              })
            : [],
          sentence_direct_object: excelDB[i].sentence_direct_object
            ? String(excelDB[i].sentence_direct_object).split(",").map((el) => {
                return Number(el);
              })
            : [],
          sentence_indirect_object: excelDB[i].sentence_indirect_object
            ? String(excelDB[i].sentence_indirect_object).split(",").map((el) => {
                return Number(el);
              })
            : [],
          sentence_complement: excelDB[i].sentence_complement
            ? String(excelDB[i].sentence_complement).split(",").map((el) => {
                return Number(el);
              })
            : [],
          sentence_adverb: excelDB[i].sentence_adverb
            ? String(excelDB[i].sentence_adverb).split(",").map((el) => {
                return Number(el);
              })
            : [],
          sentence_etc: excelDB[i].sentence_etc
            ? String(excelDB[i].sentence_etc).split(",").map((el) => {
                return Number(el);
              })
            : [],
        };
        const inputword = textFunction(text, morphemeInfomation);
        // console.log(inputword)
        excelDB[i].morpheme = inputword;
      }
      // console.log(excelDB)
      return excelDB
}

export default changeFunction